export default __webpack_public_path__ + "static/media/mp_merch_pres3.09ae1735.svg";